var _defs, _path, _rect, _polygon;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLowVolume(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    strokeWidth: 1,
    width: 29,
    height: 29,
    color: "#FFFFFF",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-6374f543b67f094e4896c5d5-1{fill:none;stroke:currentColor;stroke-miterlimit:10;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-6374f543b67f094e4896c5d5-1",
    d: "M15.68,10a2.83,2.83,0,0,1,0,4"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-6374f543b67f094e4896c5d5-1",
    x: 1.5,
    y: 8.25,
    width: 4.69,
    height: 7.5
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6374f543b67f094e4896c5d5-1",
    points: "13.69 3.56 13.69 20.44 12.05 20.44 6.19 15.75 6.19 8.25 12.05 3.56 13.69 3.56"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLowVolume);
export default __webpack_public_path__ + "static/media/low-volume.8af3456ccd2250a9dc992b0c133ae3e2.svg";
export { ForwardRef as ReactComponent };